import React from "react";
import { Link } from "react-router-dom";

const MobileVerificationPage = ({
  sheet,
  mobile,
  setMobile,
  consent,
  setConsent,
  mobileError,
setMobileError,
  otpSending,
  sendOtp,
  otpDigits,
  otpRefs,
  handleOtpPaste,
  handleOtpChange,
  handleOtpKeyDown,
  resendTimer,
  otpError,
  openSheet,
  otpVerifying,
  otpValue,
  verifyOtp,
  formattedMobile,
}) => {
  return (
    <>
      {sheet === "mobile" && (
        <>
        <div className="mobile-varification">
          <h2>Mobile Verification</h2>
            <p className="fw-sheet__sub">
            Enter your mobile number linked to Aadhaar
          </p>
        </div>

          <div className="fw-mobile-input">
            <span>🇮🇳</span>
            <strong>+91</strong>
            <i />

            <input
              type="tel"
              inputMode="numeric"
              maxLength={10}
              placeholder="Enter your mobile number"
              value={mobile}
            //   onChange={(e) => {
            //     setMobile(
            //       e.target.value.replace(/\D/g, "").slice(0, 10)
            //     );
            //     setConsent((prev) => prev); 
            //   }}
            onChange={(e) => {
  setMobile(
    e.target.value.replace(/\D/g, "").slice(0, 10)
  );
  setMobileError("");
}}
            />
          </div>
{/* 
          <label className="fw-check">
            <input
              type="checkbox"
              checked={consent}
              onChange={() => {
                setConsent((prev) => !prev);
              }}
            />

            <span>
              Allow Fundswalle to access your credit information from{" "}
              <u>RBI approved bureaus</u>.
            </span>
          </label> */}
          <label className="fw-check">
  <input
    type="checkbox"
    checked={consent}
    onChange={() => {
      setConsent((prev) => !prev);
    }}
  />

  <span>
    I hereby declare that all the above information provided by me is
    true, correct, and verified to the best of my knowledge. I agree to{" "}
    <a
      href="https://fundswalle.com/terms-conditions"
      target="_blank"
      rel="noopener noreferrer"
    >
      the Terms &amp; Conditions
    </a>{" "}
    <sup>*</sup>
  </span>
</label>

          {mobileError && <p className="fw-error">{mobileError}</p>}

          <div className="fw-actions">
            <button
              type="button"
              className="fw-btn fw-btn--ghost"
              onClick={() => openSheet(null)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="fw-btn fw-btn--primary"
              onClick={sendOtp}
              disabled={otpSending}
            >
              {otpSending ? "Sending..." : "Send OTP"}
            </button>
          </div>
        </>
      )}

      {sheet === "otp" && (
        <>
          <h2>
            Enter the OTP sent to <b>{formattedMobile}</b>
          </h2>

          <div className="fw-otp" onPaste={handleOtpPaste}>
            {otpDigits.map((digit, index) => (
              <input
                key={index}
                ref={(el) => {
                  otpRefs.current[index] = el;
                }}
                inputMode="numeric"
                maxLength={1}
                value={digit}
                placeholder="0"
                onChange={(e) =>
                  handleOtpChange(index, e.target.value)
                }
                onKeyDown={(e) =>
                  handleOtpKeyDown(index, e)
                }
              />
            ))}
          </div>

          <p className="fw-resend">
            Have not received your OTP?{" "}

            {resendTimer > 0 ? (
              <span>
                Resend in {resendTimer} seconds
              </span>
            ) : (
              <button
                type="button"
                onClick={sendOtp}
                disabled={otpSending}
              >
                Resend OTP
              </button>
            )}
          </p>

          <p className="fw-legal">
            by proceeding, you are indicating that you have read and agree
            to our{" "}
            <Link to="/terms-conditions">
              terms of use
            </Link>{" "}
            &{" "}
            <Link to="/privacy-policy">
              privacy policy
            </Link>
          </p>

          {otpError && (
            <p className="fw-error">{otpError}</p>
          )}

          <div className="fw-actions">
            <button
              type="button"
              className="fw-btn fw-btn--ghost"
              onClick={() => openSheet("mobile")}
            >
              Back
            </button>

            <button
              type="button"
              className="fw-btn fw-btn--primary"
              onClick={verifyOtp}
              disabled={
                otpVerifying ||
                otpValue.length !== 6
              }
            >
              {otpVerifying
                ? "Verifying..."
                : "Verify"}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default MobileVerificationPage;